import { useEffect, useState } from 'react';
import { PARTNERS, type PartnerBrand } from '@/lib/partners';

// Which partner a signed-in user came through (the Limelite handoff stamps it on
// the account). The header shows "Hey Joe x <partner>" for them. Cached per
// browser so the mark doesn't flash in on every page load; the server answer wins.
const KEY = 'hjPartner';

export function rememberPartner(code: string | null) {
  try { if (code) localStorage.setItem(KEY, code); else localStorage.removeItem(KEY); } catch { /* storage off */ }
}

function cached(): string | null {
  try { return localStorage.getItem(KEY); } catch { return null; }
}

export function usePartnerBrand(isAuthenticated: boolean, userId?: string | null): PartnerBrand | null {
  const [code, setCode] = useState<string | null>(() => (isAuthenticated ? cached() : null));
  useEffect(() => {
    if (!isAuthenticated) { setCode(null); return; }
    let alive = true;
    const token = localStorage.getItem('authToken') || '';
    fetch('/api/partner/me', { credentials: 'include', headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then(r => (r.ok ? r.json() : null))
      .then(d => {
        if (!alive || !d) return;
        const next = d.partner?.code || null;
        rememberPartner(next);
        setCode(next);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [isAuthenticated, userId]);
  return code ? PARTNERS[code] || null : null;
}
